module.exports = __webpack_public_path__ + "wechat.png?aa3fa2381acaf21f67a820cd70f81b25";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wechat.png
// module id = 153
// module chunks = 0